import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from 'Components/Atoms/Button/Button';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import FormProvider, { RHFInput } from 'Components/Organisms/HookForm';
import { useForm } from 'react-hook-form';
import deleteImage from 'assets/icon-delete.svg';

const magicWords = {
    ES: 'ELIMINAR',
    EN: 'DELETE',
};

export default function ConfirmationDrawer(props) {
    const { title, description, onCancel, onSubmit, onError } = props;

    const { t, i18n } = useTranslation('common');
    const magicWord = magicWords[i18n.language] || magicWords.EN;

    const schema = yup.object().shape({
        captcha: yup
            .string()
            .required()
            .transform((_value, originalValue) => originalValue.toUpperCase().trim())
            .oneOf([magicWord], t('invalid-magic-word', { magicWord })),
    });

    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            captcha: '',
        },
    });

    const {
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    const submit = async () => {
        try {
            await onSubmit();
        } catch (error) {
            onError(error);
        }
    };

    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(submit)} className="flex flex-col h-full">
            <div className="my-6">
                <div className="text-center mb-6">
                    <div className="mb-6 flex justify-center">
                        <img src={deleteImage} alt="" />
                    </div>
                    <div className="text-lg font-semibold mb-1 text-dark-blue">{title}</div>
                    <div className="mb-8 text-gray-500 text-sm">{description}</div>
                </div>

                <div className="py-3">
                    <RHFInput data-autofocus="true" label={t('write-magic-word', { magicWord })} name="captcha" />
                </div>
            </div>

            <div className="grow" />

            <div className="sticky bottom-0 bg-white pt-2 pb-4 z-10">
                <div className="flex gap-2">
                    <Button
                        isBusy={isSubmitting}
                        variant="primary"
                        className="grow"
                        type="submit"
                        testId="confirmation.delete"
                    >
                        {t('delete')}
                    </Button>
                    <Button variant="default" className="grow" onClick={onCancel} testId="confirmation.cancel">
                        {t('cancel')}
                    </Button>
                </div>
            </div>
        </FormProvider>
    );
}

ConfirmationDrawer.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};
